import React, { useState, useEffect } from "react";
import Slider from 'react-slick';
import { directions } from "../common/utils/animations/animationConstants";
import Parallax from "../common/utils/animations/parallax";

export default function ThreeColSlider(props) {
  const [clientWidth, setclientWidth] = useState(0);
  let triggers = [[1.2, 0.8], [0.9, 0.7], [1.2, 0.8], [0.9, 0.7], [1.2, 0.8], [0.9, 0.7], [1.2, 0.8], [0.9, 0.7], [1.2, 0.8], [0.9, 0.7]];
  if (clientWidth < 1681) {
    triggers.map((t, i) => {
      t[0] += 0.05;
      t[1] += 0.05;
    }
    );
  }
  const setValues = () => {
    setclientWidth(window.innerWidth);
  };

  useEffect(() => {
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  });

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  const { header, subHeader, items, classes } = props.data;
  return (
    <div className={`three-col-slider-section section-gap ${classes}`} id={props.id ? props.id : ''} onLoad={setValues}>
      <div className="container">
        <div className="three-col-slider-title">
          <div className="slider-title-inner">
            <h2 className="h4">{header}</h2>
          </div>
        </div>
        <div className="three-col-slider-block">
          <div className="row three-col-slider-list d-flex flex-wrap">
            {clientWidth >= 767 && <>
              {/* <Slider {...settings}> */}
              {items.map((item, index) => {
                return (<Parallax key={index} classes="col three-col-slider-item" id={"three-col-slider-item" + index} triggers={triggers[index]} direction={directions.RTL} opacity={true} length={100}>
                  <div className="slider-item-inner d-flex">
                    <div className="grid-icon">
                      <i>
                        {item.icon}
                      </i>
                    </div>
                    <div className="grid-content">
                      <h3 className="h6">{item.header}</h3>
                      <p>{item.content}</p>
                    </div>
                  </div>
                </Parallax>);
              })}
              {/* </Slider> */}
            </>}
            {clientWidth <= 767 && <>
              <Slider {...settings}>
                {items.map((item, index) => {
                  return (<div key={index} className="col three-col-slider-item">
                    <div className="slider-item-inner d-flex">
                      <div className="grid-icon">
                        <i>
                          {item.icon}
                        </i>
                      </div>
                      <div className="grid-content">
                        <h3 className="h6">{item.header}</h3>
                        <p>{item.content}</p>
                      </div>
                    </div>
                  </div>);
                })}
              </Slider>
            </>}
          </div>
        </div>
      </div>
    </div >
  );
}